module.exports = __webpack_public_path__ + "media/packs/landing_page/images/Instagram-df0eb6ae9a48fa8d36c120ece0fcadfc.png";